const toolLinks = [
  { label: "检索历史快照", href: "#search" },
  { label: "快照时间线查看", href: "#search" },
  { label: "版本并排对比", href: "#compare" },
  { label: "核心能力", href: "#features" },
];

const browseLinks = [
  { label: "热点事件存档", href: "#search" },
  { label: "综艺娱乐主页", href: "#search" },
  { label: "社会热议报道", href: "#search" },
  { label: "品牌公关声明", href: "#search" },
  { label: "行业动态公告", href: "#search" },
];

const aboutLinks = [
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
  { label: "提交页面追溯", href: "#contact" },
  { label: "用户口碑", href: "#about" },
];

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-300 bg-background-100 text-foreground-700">
      <div className="mx-auto max-w-7xl px-4 pb-8 pt-12 md:px-6 md:pt-16">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          <div className="col-span-2 md:col-span-1">
            <a href="#home" className="flex items-center gap-2.5" aria-label="吃瓜网页">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-archive-2-line text-xl"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl text-foreground-950">吃瓜网页</span>
                <span className="text-[10px] tracking-wide text-foreground-500">快照 · 缓存 · 存档</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-6">
              专注网页历史快照、缓存版本与旧版存档查看，让每一段被删改的公开内容都有据可查、随时可溯。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a href="mailto:service@chigua-web.example.com" rel="nofollow" aria-label="邮箱" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 ring-1 ring-background-200 hover:text-primary-600">
                <i className="ri-mail-line"></i>
              </a>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 ring-1 ring-background-200">
                <i className="ri-question-line"></i>
              </span>
            </div>
          </div>

          <nav aria-label="快照工具">
            <h4 className="text-sm font-semibold text-foreground-950">快照工具</h4>
            <ul className="mt-4 space-y-2.5">
              {toolLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="whitespace-nowrap text-sm hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="浏览方向">
            <h4 className="text-sm font-semibold text-foreground-950">浏览方向</h4>
            <ul className="mt-4 space-y-2.5">
              {browseLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="whitespace-nowrap text-sm hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="关于网站">
            <h4 className="text-sm font-semibold text-foreground-950">关于网站</h4>
            <ul className="mt-4 space-y-2.5">
              {aboutLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="whitespace-nowrap text-sm hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
            <div className="mt-5 rounded-lg bg-background-50 p-3 text-xs leading-5 text-foreground-600 ring-1 ring-background-200">
              客服工作日上午 9:00–12:00、下午 14:00–18:00 在线
            </div>
          </nav>
        </div>

        <div className="mt-12 flex flex-col gap-2 border-t border-background-300 pt-6 text-xs leading-6 text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 吃瓜网页历史快照 · 保留所有权利</p>
          <p className="max-w-xl sm:text-right">
            本站仅提供公开网页的只读快照留痕与缓存版本查看服务，不参与事件演绎，涉及隐私与违规内容不予展示。
          </p>
        </div>
      </div>
    </footer>
  );
}